<template>
  <div
    class="cell"
    :class="'cell__' + column"
    :style="{
      background: background,
    }"
  >
    <template v-if="column === 'worker'">
      <div class="worker-name">
        <c-button2
          :id="'remove-worker-' + worker.id"
          class="worker-name__remove"
          size="small"
          :icon="{
            icon: 'times-bold',
          }"
          @click="$emit('remove', { worker, position })"
        />
        <b-popover placement="top" triggers="hover" :target="'remove-worker-' + worker.id">
          Удалить сотрудника
        </b-popover>
        <div class="worker-name__wrapper">
          <router-link
            class="worker-name__name"
            :to="{
              name: 'personal-employee-summary',
              params: { id: worker.id },
            }"
          >
            {{ worker.name }}
          </router-link>
          <div v-if="worker.filial.id !== filial" class="worker-name__filial">
            {{ worker.filial.filial_name }}
          </div>
        </div>
        <div v-if="worker.jobStatus.fired" class="worker-name__actions">
          <div v-if="worker.jobStatus.fired" :id="'worker-fired-' + worker.id">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 8.99976C5.55228 8.99976 6 8.55204 6 7.99976C6 7.44747 5.55228 6.99976 5 6.99976V8.99976ZM3.49264 7.99976V6.99976V7.99976ZM1 10.6475H0H1ZM0 10.9998C0 11.552 0.447715 11.9998 1 11.9998C1.55228 11.9998 2 11.552 2 10.9998H0ZM11.7071 8.70686C12.0976 8.31634 12.0976 7.68317 11.7071 7.29265C11.3166 6.90212 10.6834 6.90212 10.2929 7.29265L11.7071 8.70686ZM7.29289 10.2926C6.90237 10.6832 6.90237 11.3163 7.29289 11.7069C7.68342 12.0974 8.31658 12.0974 8.70711 11.7069L7.29289 10.2926ZM8.70711 7.29265C8.31658 6.90212 7.68342 6.90212 7.29289 7.29265C6.90237 7.68317 6.90237 8.31634 7.29289 8.70686L8.70711 7.29265ZM10.2929 11.7069C10.6834 12.0974 11.3166 12.0974 11.7071 11.7069C12.0976 11.3163 12.0976 10.6832 11.7071 10.2926L10.2929 11.7069ZM5 6.99976H3.49264V8.99976H5V6.99976ZM3.49264 6.99976C2.54619 6.99976 1.65165 7.39969 1.00196 8.08982L2.45819 9.46073C2.74342 9.15775 3.11692 8.99976 3.49264 8.99976V6.99976ZM1.00196 8.08982C0.354196 8.7779 0 9.69892 0 10.6475H2C2 10.1917 2.17104 9.76576 2.45819 9.46073L1.00196 8.08982ZM0 10.6475V10.9998H2V10.6475H0ZM6.99411 2.98559C6.99411 3.52614 6.55296 3.97143 6 3.97143V5.97143C7.64968 5.97143 8.99411 4.63854 8.99411 2.98559H6.99411ZM6 3.97143C5.44704 3.97143 5.00589 3.52614 5.00589 2.98559H3.00589C3.00589 4.63854 4.35032 5.97143 6 5.97143V3.97143ZM5.00589 2.98559C5.00589 2.44505 5.44704 1.99976 6 1.99976V-0.000244141C4.35032 -0.000244141 3.00589 1.33265 3.00589 2.98559H5.00589ZM6 1.99976C6.55296 1.99976 6.99411 2.44505 6.99411 2.98559H8.99411C8.99411 1.33265 7.64968 -0.000244141 6 -0.000244141V1.99976ZM10.2929 7.29265L8.79289 8.79265L10.2071 10.2069L11.7071 8.70686L10.2929 7.29265ZM8.79289 8.79265L7.29289 10.2926L8.70711 11.7069L10.2071 10.2069L8.79289 8.79265ZM7.29289 8.70686L8.79289 10.2069L10.2071 8.79265L8.70711 7.29265L7.29289 8.70686ZM8.79289 10.2069L10.2929 11.7069L11.7071 10.2926L10.2071 8.79265L8.79289 10.2069Z"
                fill="#FF238D"
              />
            </svg>
          </div>

          <b-popover placement="top" triggers="hover" :target="'worker-fired-' + worker.id">
            Статус сотрудника {{ worker.jobStatus.name }}
          </b-popover>
        </div>
      </div>
    </template>

    <template v-if="column === 'loadType'">
      <div :id="'load-type-' + position.code + '-' + worker.id" class="load-type">
        {{ position.loadType }}
      </div>

      <b-popover placement="top" triggers="hover" :target="'load-type-' + position.code + '-' + worker.id">
        {{ position.loadType }}
      </b-popover>
    </template>

    <template v-if="column === 'days'">
      <div class="timeline">
        <div
          v-for="day in worker.days"
          :key="day.key"
          class="day"
          :class="{
            conflict: day.hasConflict,
          }"
          @click="onDayClick(day)"
        >
          <div v-if="day.vacations.length" class="day-vacations">
            <span
              v-for="vacation in day.vacations"
              :id="'vacation-' + vacation.id + '-' + day.key"
              :key="vacation.id"
              :style="{
                'background-color': (vacation.type && vacation.type.color) || '#DFE4EF',
              }"
            >
              {{ (vacation.type && vacation.type.timesheet_code) || "О" }}

              <b-popover placement="top" triggers="hover" :target="'vacation-' + vacation.id + '-' + day.key">
                <div>
                  {{ (vacation.type && vacation.type.name) || "Отпуск" }},
                  {{ vacation.fromDate.format("DD.MM.YYYY") }}-{{ vacation.toDate.format("DD.MM.YYYY") }}
                </div>
              </b-popover>
            </span>
          </div>

          <span v-else-if="day.visibleTimesheet && day.visibleTimesheet.shifts.length" class="day-shifts">
            <span class="day-shifts__hours">
              {{ day.visibleTimesheet.totalTime }}
            </span>
            <span class="day-shifts__icons">
              <span v-if="day.visibleTimesheet.hasDayShift && day.visibleTimesheet.hasNightShift">
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3 5.99976C3 7.65661 4.34315 8.99976 6 8.99976V10.9998M3 5.99976C3 4.3429 4.34315 2.99976 6 2.99976V0.999756M3 5.99976H1M2.46448 9.53528L3.50003 8.49973M3.50003 3.49976L2.46449 2.46421M8.75195 4.25729C9.75131 3.11569 11.4296 2.91098 12.7035 3.70321C11.8052 4.25729 11.0269 5.0541 11.0268 6.24237C11.0268 7.43065 11.8052 8.2275 12.7035 8.78159C11.4296 9.57381 9.75131 9.3691 8.75195 8.2275C8.25409 7.65879 7.9855 7.07339 7.9855 6.24237C7.98551 5.41137 8.25409 4.82601 8.75195 4.25729Z"
                    stroke="#BFC9E0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span v-else-if="day.visibleTimesheet.hasNightShift">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.21206 0.999756C2.26415 1.45382 0.874839 3.22915 1.00894 5.24767C1.07574 6.25324 1.37442 7.05834 2.15788 7.84182C2.94136 8.62532 3.74651 8.92401 4.75209 8.99082C6.77061 9.12492 8.54593 7.7356 9 5.7877C7.63077 6.11214 6.1456 6.09475 5.02529 4.97442C3.90499 3.85409 3.88761 2.36899 4.21206 0.999756Z"
                    stroke="#BFC9E0"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </span>
          </span>

          <template v-else>
            <span class="day-off">В</span>
          </template>
        </div>
      </div>
    </template>

    <template v-if="column === 'totalShifts'">
      <div class="shifts">
        <div v-if="worker.dayShiftsCount || worker.calcDayShiftsCount">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 5.99976C9 7.65661 7.65685 8.99976 6 8.99976M9 5.99976C9 4.3429 7.65685 2.99976 6 2.99976M9 5.99976H11M6 8.99976C4.34315 8.99976 3 7.65661 3 5.99976M6 8.99976V10.9998M3 5.99976C3 4.3429 4.34315 2.99976 6 2.99976M3 5.99976H1M6 2.99976V0.999756M8.5 3.49976L9.53555 2.46421M2.46448 9.53528L3.50003 8.49973M3.50003 3.49976L2.46449 2.46421M9.53555 9.53528L8.5 8.49973"
              stroke="#BFC9E0"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          {{ worker.dayShiftsCount }}/{{ worker.calcDayShiftsCount }}
        </div>
        <div v-if="worker.nightShiftsCount || worker.calcNightShiftsCount">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.21206 0.999756C2.26415 1.45382 0.874839 3.22915 1.00894 5.24767C1.07574 6.25324 1.37442 7.05834 2.15788 7.84182C2.94136 8.62532 3.74651 8.92401 4.75209 8.99082C6.77061 9.12492 8.54593 7.7356 9 5.7877C7.63077 6.11214 6.1456 6.09475 5.02529 4.97442C3.90499 3.85409 3.88761 2.36899 4.21206 0.999756Z"
              stroke="#BFC9E0"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {{ worker.nightShiftsCount }}/{{ worker.calcNightShiftsCount }}
        </div>
        <div v-if="noCountValue">0</div>
      </div>
    </template>

    <template v-if="column === 'workTime'">
      <div class="work-time">
        <div>{{ formatTime(worker.totalTimeMin) }}</div>
        <div>{{ formatTime(worker.calcTotalTimeMin) }}</div>
      </div>
    </template>

    <template v-if="column === 'compensation'">
      {{ worker.compensation.toLocaleString() }}
    </template>

    <template v-if="column === 'load'">
      {{ worker.load.toLocaleString() }}
    </template>

    <template v-if="column === 'salary'">
      {{ (worker.salary || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'salaryMainPart'">
      <div class="salary-main">
        <div>{{ Math.floor(worker.salaryMain || 0).toLocaleString() }}</div>
        <div>{{ Math.floor(worker.calcSalaryMain || 0).toLocaleString() }}</div>
      </div>
    </template>

    <template v-if="column === 'excessPremium'">
      {{ worker.excessPremium.toLocaleString() }}
    </template>

    <template v-if="column === 'Depreciation'">
      {{ worker.depreciation.toLocaleString() }}
    </template>

    <template v-if="column === 'premium'">
      {{ worker.premium.toLocaleString() }}
    </template>

    <template v-if="column === 'fine'">
      {{ worker.fine.toLocaleString() }}
    </template>

    <template v-if="column === 'penalties'">
      {{ worker.penalties.toLocaleString() }}
    </template>

    <template v-if="column === 'totalAccrued'">
      {{ worker.totalAccrued.toLocaleString() }}
    </template>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";

export default {
  components: {
    CButton2,
  },
  props: ["column", "worker", "position", "filial"],

  computed: {
    background() {
      if (this.column === "premium" && this.worker.premium > 0) return "#D0F4E3";
      if (this.column === "fine" && this.worker.fine > 0) return "#FFE6F2";
      if (this.column === "totalAccrued" && this.worker.totalAccrued > 0) return "#E1EDFF";
      return "";
    },
    noCountValue() {
      return (
        !this.worker.dayShiftsCount &&
        !this.worker.nightShiftsCount &&
        !this.worker.calcDayShiftsCount &&
        !this.worker.calcNightShiftsCount
      );
    },
  },
  watch: {
    shifts() {},
  },

  methods: {
    getVisibleShifts() {},
    onDayClick(day) {
      this.$emit("onDayClick", {
        day,
        worker: this.worker,
        position: this.position,
      });
    },
    formatTime(min = 0) {
      let h = Math.floor(min / 60);
      let m = min % 60;

      h = `${h}`.padStart(2, "0");
      m = `${m}`.padStart(2, "0");

      return `${h}:${m}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";

.cell {
  display: flex;
  line-height: 1.4;
  &__worker {
    width: 100%;
  }
  .load-type {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75px;
  }
  .worker-name {
    display: flex;
    align-items: center;
    line-height: 1.2;
    width: 100%;

    word-break: break-word;

    a {
      text-decoration: none;
    }

    &__wrapper {
      flex-grow: 1;
    }

    &__filial {
      color: #8e9cbb;
      font-size: 11px;
    }

    &__actions {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 6px;
    }

    &__remove {
      width: 22px;
      height: 22px;
      margin-right: 10px;
      flex-shrink: 0;

      & /deep/ svg {
        width: 8px;
        height: 8px;
        margin-left: -4px;
        margin-top: -4px;
      }
    }
  }
  .timeline {
    display: flex;
    margin-top: -1px;
    margin-bottom: -1px;
    margin-right: -1px;
  }
  .day {
    width: 24px;
    flex-shrink: 0;
    cursor: pointer;
    border: 1px solid #dfe4ef;
    margin-left: -1px;
    position: relative;
    display: flex;
    flex-direction: column;

    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: -2px;
      right: -2px;
      bottom: -1px;
      border: 2px solid transparent;
      z-index: 1;
      border-left-color: transparent;
      border-right-color: transparent;
    }

    &.conflict {
      position: relative;
      &:before {
        border-top-color: #ff238d;
        border-bottom-color: #ff238d;
      }
      &:last-child:before {
        border-right-color: #ff238d;
      }
    }

    &:not(.conflict) + .conflict {
      &:before {
        border-left-color: #ff238d;
      }
    }

    &.conflict + .day:not(.conflict) {
      &:before {
        border-left-color: #ff238d;
        left: -1px;
      }
    }

    &.conflict:first-child {
      &:before {
        border-left-color: #ff238d;
      }
    }

    .day-off {
      flex-grow: 1;
      flex-basis: 100%;
      display: flex;
      justify-content: center;
      width: 100%;
      padding-top: 8px;
      padding-bottom: 10px;
    }

    .day-shifts {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      flex-basis: 100%;
      align-items: center;
      justify-content: space-between;
      padding-top: 8px;
      padding-bottom: 10px;
    }

    .day-vacations {
      position: relative;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      flex-basis: 100%;

      span {
        display: flex;
        justify-content: center;
        flex-grow: 1;
        flex-basis: 100%;
        padding: 8px 0;

        &:not(:last-child) {
          border-bottom: 1px solid #dfe4ef;
        }
      }
    }

    span.day-off {
      background: #d9f8f8;
    }
  }
}
</style>
